import { fromJS } from 'immutable';
import { setDropdownValuesType } from './ResultsPaginationConstants';

export const initialState = fromJS({
  dropdownValues: [],
});

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  if (action.type === setDropdownValuesType) {
    const { dropdownValues } = action;
    return state.set('dropdownValues', dropdownValues);
  }
  return state;
}
